import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsCustomersListCreateRoute extends Route {
  @service store;

  model() {
    return this.store.createRecord('customer');
  }
}

export default instrumentRoutePerformance(SettingsCustomersListCreateRoute);
